import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

class PrivateRoute extends React.Component {
    render() {
        const { component: Component, ...rest } = this.props;
        return (
            <Route {...rest} render={props => (
                this.props.authentication.isAuthenticated ? (
                    <Component {...props}/>
                ) : (
                    <Redirect to={{
                        pathname: '/sign-in',
                        state: { from: props.location }
                    }}/>
                )
            )}/>
        )
    }
}

export default connect(
    state => ({ authentication: state.authentication }),
    dispatch => ({ dispatch })
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js